import Cookie from 'js-cookie';
import { LeadFormContactInfo } from 'types/LeadForm';

// this must match the core cookie name
export const LEAD_COOKIE_NAME = 'most_recent_lead_submission';

export function saveMostRecentLeadSubmission(contactInfo: LeadFormContactInfo): void {
  Cookie.set(LEAD_COOKIE_NAME, JSON.stringify(contactInfo));
}

export function clearMostRecentLeadSubmission(): void {
  Cookie.remove(LEAD_COOKIE_NAME);
}

export function getMostRecentLeadSubmission(): LeadFormContactInfo | undefined {
  const raw = Cookie.get(LEAD_COOKIE_NAME);
  if (!raw) {
    return undefined;
  }

  return JSON.parse(raw) as LeadFormContactInfo;
}
